import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT
  ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
  : "";

/**
 * Fetch exit items for the analyzer
 */
export const fetchExitData = async ({ indexName, optionType, onlyDate, expiry, isExpiry, exitClassName }) => {
  const params = { indexName, optionType, onlyDate };
  if (expiry) params.expiry = expiry;
  if (isExpiry !== undefined && isExpiry !== null) params.isExpiry = isExpiry;
  if (exitClassName) params.exitClassName = exitClassName;
  const response = await axios.get(`${API_URL}api/exit-analyzer`, { params });
  return response.data;
};

/**
 * Fetch metadata (available expiries and dates) for filter dropdowns
 */
export const fetchMeta = async ({ indexName, optionType }) => {
  const params = { indexName };
  if (optionType) params.optionType = optionType;
  const response = await axios.get(`${API_URL}api/exit-analyzer/meta`, { params });
  return response.data;
};
